/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import queryString from 'query-string';
import { route as LoginRoute } from '../LoginView';
import validateRedirectURI from '../common/helpers';

class Auth extends React.Component {
  componentDidMount() {
    localStorage.removeItem('refresh-token-inprogress');
    const { redirect, ...rest } = queryString.parse(this.props.location.search);
    let redierctURL = redirect;
    if (redierctURL && !validateRedirectURI(redierctURL)) {
      window.location.href = LoginRoute.path;
    } else {
      const otherQueryParms = Object.entries(rest).reduce((acc, [key, value]) => `${acc}&${key}=${value}`, '');
      if (!redierctURL) {
        redierctURL = this.props.redirectTo;
      }
      this.props.validateToken(`${redierctURL}${otherQueryParms}`);
      window.localStorage.setItem('external', this.props.isExternalUser);
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    if (nextProps.validToken && nextProps.requestProcessed) {
      window.location = nextProps.redirectTo;
      window.localStorage.setItem('external', nextProps.isExternalUser);
    }
  }

  render() {
    const { validToken, requestProcessed } = this.props;
    const loginRedirect = (<Redirect to={LoginRoute.path} />);
    const wait = (<div>Please Wait...</div>);
    return (!validToken && requestProcessed) ? loginRedirect : wait;
  }
}

Auth.propTypes = {
  validateToken: PropTypes.func.isRequired,
  validToken: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string,
  requestProcessed: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  isExternalUser: PropTypes.bool
};
Auth.defaultProps = {
  redirectTo: '/login',
  isExternalUser: false
};

export default Auth;